/**
 * @generated SignedSource<<fb0e0f66fc0ebd527d17a544e88b239b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedPrintDetails_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedItemDetailsAdditionalOptions_user" | "PdpRespSharedItemDetailsList_user">;
  readonly " $fragmentType": "PdpRespSharedPrintDetails_user";
};
export type PdpRespSharedPrintDetails_user$key = {
  readonly " $data"?: PdpRespSharedPrintDetails_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedPrintDetails_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedPrintDetails_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedItemDetailsList_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedItemDetailsAdditionalOptions_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "cbfb703f3303844db1d8b60ce3640b24";

export default node;
